// extracted by mini-css-extract-plugin
export default {"hideTooltip":"Z9-z","fadeIn":"_9-z","delay":"a--z","recommendedSizeTooltip":"b--z"};